module.exports = __webpack_public_path__ + "static/media/Phone.c8a7c75b.svg";